export let hres88eColumns = () => {
  let indexColumns = [{
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 80px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '40',
    style: 'min-width: 150px;'
  }, {
    key: 'remarkap',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'next_codappr',
    name: '',
    labelCodapp: 'HRES88EC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}




// WEBPACK FOOTER //
// ./src/assets/columns/hres88e.js